import React, { useMemo } from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import advertisementService from "../../../services/advertisement.service";
import { useSelector } from "react-redux";

const initialValues = {
    title: "",
    href: "",
    category: "",
    description: "",
    showInRow: "",
    image: "",
};

const schema = Yup.object().shape({
    title: yupSchema.titleOp,
    href: yupSchema.href,
    category: yupSchema.category,
    description: yupSchema.description,
    image: yupSchema.image,
});

export default function FormModalContent({ close, data }) {

    const errorHandler = useErrorHandler();
    const { initials } = useSelector((state) => state.app);

    const handleSubmit = async (model, { setSubmitting }) => {
        let op;
        if(model.showInRow === null) model.showInRow = ""
        if (data?.id) {
            op = await advertisementService.editAdvertisement(data.id, model);
        } else {
            op = await advertisementService.createAdvertisement(model);
        }
        const { error } = op;
        setSubmitting(false);
        if (error) return errorHandler(error);

        close(true);
    };

    const form = useMemo(() => [
        {
            _type: "textField",
            name: "title",
            label: "عنوان",
            autoFocus: true,
        },
        {
            _type: "textField",
            name: "description",
            label: "توضیح",
        },
        {
            _type: "autocomplete",
            _empty: undefined,
            name: "category",
            options: [...(initials?.enums?.advertisementCategory || [])],
            label: "نمایش در صفحه",
            disableClearable: true,
            valueSelector: "value",
            labelSelector: "title",
        },
        {
            _type: "textField",
            name: "showInRow",
            label: "نمایش در ردیف",
            type: "number",
        },
        {
            _type: "textField",
            name: "href",
            label: "آدرس مقصد",
        },
        {
            _type: "filePicker",
            name: "image",
            label: "عکس",
            isImage: true,
        },
    ], [initials])

    return (
        <DialogFormBuilder
            {...{
                close,
                name: "تبلیغ",
                data,
                schema,
                initialValues,
                handleSubmit,
                form,
            }}
        />
    );
}
